import { render, staticRenderFns } from "./usersetting.vue?vue&type=template&id=63ec7a62&scoped=true"
import script from "./usersetting.vue?vue&type=script&lang=js"
export * from "./usersetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec7a62",
  null
  
)

export default component.exports